import { render, staticRenderFns } from "./Academica.vue?vue&type=template&id=67cc6c90"
import script from "./Academica.vue?vue&type=script&lang=js"
export * from "./Academica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports